import React from "react";
import useFileNameLength from "../../../../hooks/useFileNameLength";
import { WORKING_RIGHTS_OPTIONS } from "../../../../models/Onboarding/onboarding-values";
import { ICandidateDetails } from "../../../../store/superadmin/types";
import { formatFileName } from "../../../../utils/stringUtils";
import CustomButton from "../../../UI/Buttons/CustomButton";
import Download from "../../../UI/Icons/Download";

interface ClientPersonalDetailProps {
  showPersonalDetails: boolean;
  reviewCandidateData: ICandidateDetails | null;
  handleDownloadDocument: (url: string) => void;
}

const ClientPersonalDetails: React.FC<ClientPersonalDetailProps> = ({
  showPersonalDetails,
  reviewCandidateData,
  handleDownloadDocument,
}) => {
  const { maxLength, preserveEndChars } = useFileNameLength();

  const getWorkingRightsText = (rights: string) => {
      switch (rights) {
        case "australian_citizen":
          return WORKING_RIGHTS_OPTIONS.australian_citizen;
        case "australian_permanent_resident":
          return WORKING_RIGHTS_OPTIONS.australian_permanent_resident;
        case "australian_visa_holder":
          return WORKING_RIGHTS_OPTIONS.australian_visa_holder;
        case "new_zealand_citizen":
          return WORKING_RIGHTS_OPTIONS.new_zealand_citizen;
        case "dont_have_australia_working_rights":
          return WORKING_RIGHTS_OPTIONS.dont_have_australia_working_rights;
        default:
          return "No data";
      }
    }

  return (
      <div
        className={`d-flex flex-column gap-20 fw-400 text-black text-break ${
          showPersonalDetails ? "" : "d-none"
        }`}
      >
        <div className="fs-22">Personal Details</div>
        <div className="d-flex flex-column gap-10">
         
          <div className="d-flex flex-column gap-5">
            {reviewCandidateData?.profile?.resume !== null ? (
              <>
                <div className="fs-13 text-grey-medium">Resume</div>
                <div className="d-flex">
                  <CustomButton
                    variant={"primary"}
                    type="button"
                    className="btn-theme bg-off-white text-black"
                    onClick={() => {
                      handleDownloadDocument(
                        reviewCandidateData?.profile?.resume ?? ""
                      );
                    }}
                  >
                    <Download />
                    {formatFileName(
                      reviewCandidateData?.profile?.resume_name ??
                      "Not Provided",
                      maxLength,
                      preserveEndChars
                    )}
                  </CustomButton>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="d-flex flex-column gap-5">
            <div className="fs-13 text-grey-medium">
              Do you have current working rights in Australia?
            </div>
            <div className="fs-16">
              {getWorkingRightsText(typeof reviewCandidateData?.profile?.working_rights === "string" ? reviewCandidateData?.profile?.working_rights : "")}
            </div>
          </div>
          <div className="d-flex flex-column gap-5">
            <div className="fs-13 text-grey-medium">
              Are you interested in permanent employment?
            </div>
            <div className="fs-16">
              {reviewCandidateData?.profile.permanent_employment
                ? "Yes"
                : "No"}
            </div>
          </div>
        </div>
      </div>
  );
};

export default ClientPersonalDetails;
